import request from '../untils/request';

export const activityLotteryListApi = params => {
  return request({
    url: '/operation/lottery/index',
    authCode: 'LOTTERY_INDEX',
    params,
  });
};

export const activityLotteryUpdateApi = params => {
  return request({
    url: '/operation/lottery/update',
    authCode: 'LOTTERY_INDEX',
    params,
  });
};

export const activityLotteryDeleteApi = params => {
  return request({
    url: '/operation/lottery/delete',
    authCode: 'LOTTERY_INDEX',
    params,
  });
};

export const activityLotteryLogApi = params => {
  return request({
    url: '/operation/lottery/log',
    params,
    authCode: 'LOTTERY_INDEX'
  });
};
